module.exports = __webpack_public_path__ + "img/ge.948ba6b.svg";